import { SET_USER_PERMISSIONS, UserPermissions } from "./app-global-types";

export const setUserPermissions = (userPermissions: UserPermissions) => ({
    type: SET_USER_PERMISSIONS,
    userPermissions,
});
